import { SESSION_READY, MOVE_ANIMATION_MIDDLE, MOVE_ANIMATION_END, POST_ANIMATION_END } from './consts';
import { gsap } from 'gsap';

/* ТУТ ПО ИДЕЕ СОЧИТАЕТСЯ И ГРАФИКА И ВЫВОД И UI */

export default class NggGraphEngine {

    constructor(props) {
        const {
            messageEndpoint,
            settings
        } = props;
        this.settings = settings;
        this.messageEndpoint = (message, props = null) => messageEndpoint(message, props);
    }

    // оба персонажа выбрали что они будут делать
    firstAnimationStart = ({ char, snowman, outtime }) => {
        const { point, type, technics } = char || {};
        if (type === 'strike' || type === 'defence') {
            if (technics) {
                this.setCharAnimation({ technics, immideatly: true });
            }
        }

        const { point: pointSnowMan } = snowman ? snowman : { point: 0 };
        pointSnowMan && this.setSnowManAnimation({ ...snowman })

        const { cicleTime } = this.settings;


        // это когда вышел таймер - нам не надо ждать никакие середины анимации и т.д.
        if (outtime) {
            setTimeout(() => {
                this.messageEndpoint(MOVE_ANIMATION_MIDDLE);
            }, 1)

            setTimeout(() => {
                this.messageEndpoint(MOVE_ANIMATION_END);
            }, 5)
        } else {
            setTimeout(() => {
                this.messageEndpoint(MOVE_ANIMATION_MIDDLE);
            }, cicleTime * 5)

            setTimeout(() => {
                this.messageEndpoint(MOVE_ANIMATION_END);
            }, cicleTime * 10)
        }
    }

    postAnimationStart = () => {
        this.messageEndpoint(POST_ANIMATION_END);
    }

    setCharAnimation = (props = {}) => {
        this.arenaRef.addCharAnimation(props);
    }

    setSomeAnimation = (type, props) => {


        if (type === 'snowmanStriked') {
            this.arenaRef.hittedSnowMan(props);
        }
        if (type === 'noDamage') {
            this.arenaRef.hittedSnowMan({ ...props, type });
        }
        if (type === 'deflectDestroyed') {
            this.arenaRef.hittedSnowMan({ ...props, type });
        }
        if (type === 'deflectHitted') {
            this.arenaRef.hittedSnowMan({ ...props, type });
        }
        if (type === 'armorDestroyed') {
            this.arenaRef.hittedSnowMan({ ...props, type });
        }
        if (type === 'armorHitted') {
            this.arenaRef.hittedSnowMan({ ...props, type });
        }
        if (type === 'snowmanDead') {
            this.arenaRef.hittedSnowMan({ ...props, type: 'dead' });
        }
        if (type === 'buffAdded') {
            const { persNumber } = props;
            if (persNumber === 2) {
                this.setSnowManAnimation({ ...props, type })
            }
            if (persNumber === 1) {
                this.setCharAnimation({ ...props, type })
            }
        }
        if (type === 'spicesHitted') {
            this.setCharAnimation({ hitted: true })
        }
        return;
    }

    setSnowManAnimation = (props) => {
        this.arenaRef.setSnowManAnimation(props);
    }

    //{ Pers, index }
    changeLive = (props) => {
        this.arenaRef.changeLive(props)
    }

    changePers2Buffs = (props) => {
        this.arenaRef.changePers2Buffs(props)
    }

    changePers1Buffs = (props) => {
        this.arenaRef.changePers1Buffs(props)
    }

    setBlocks = (props) => {
        this.arenaRef.setBlocks(props)
    }

    setMoveListExtras = (props) => {
        this.arenaRef.setMoveListExtras(props)
    }

    moveTo = (person) => {
        this.arenaRef.cameraOnPerson({ person });
    }

    addEnemy = (props) => {
        this.arenaRef.addEnemy(props);
    }

    setArenaRef = (arenaRef) => {
        this.arenaRef = arenaRef;
    }

    startGame = (props) => {
        this.arenaRef.startGame(props);
    }

    stopGame = (props) => {
        this.arenaRef.stopGame(props);
    }

    // TIME TO THINK
    startTimeToThink = (timeToThink) => {
        const ref = this.arenaRef.getThinkTimeRef;
        ref.setNewTimer(timeToThink);
    }

    setCaveSession = (caveSession) => {
        this.caveSession = caveSession;
    }

}